import Api from "../services/Api";
import { getAuthHeader } from "../services/GetAuth";

export const getSubs = async (scanId: string) => {
  const config = await getAuthHeader();

  return Api.get(`/subs?scanId=${scanId}`, config);
}